module.exports = __webpack_public_path__ + "img/logo-pkl-web-bianco.21330102.png";